<template>
    <a-layout style="min-height: 100vh;"  >

        <!-- The Main Navigation -->
        <a-layout-sider width="250" class="basic_layout-layout_sider">
            <div class="main-logo-container">
                <img src="~@/assets/images/base-logo.png" class="logo" alt="logo" @click="skip_url('/login')">
            </div>
            <hr class="mini-split-line">

            <a-menu theme="dark" mode="inline" :selectedKeys="selectedKeys" :openKeys="openkeys" @openChange="openChange"
                    class="BasicLayout_amenu">

                <template v-for="(value, index) in router_list">

                    <a-menu-item v-if="value['children'].length === 0" @click="skip_url(value['path'])" :key="value['path']" >
                        <span :style="{fontSize: global_fontsize + 'px', }">{{value['meta']['title']}}</span>
                    </a-menu-item>

                    <a-sub-menu v-if="value['children'].length !== 0 && role_check(value['meta']['role'])" :key="`${index}_1`" >
                        <template #title>
                            <span :style="{fontSize: global_fontsize + 'px', }">{{value['meta']['title']}}</span>
                        </template>
                        <div v-for="( value2 ) in value['children']" v-bind:key="value2['path']">
                            <a-menu-item @click="skip_url(value2['path'])"
                            v-if="role_check(value2['meta']['role'])"
                            class="navigation-menu-item"
                            :key="value2['path']"
                            :style="{fontSize: global_fontsize + 'px', }"
                            >
                                <a-tooltip placement="rightTop" :title="value2['meta']['title']"
                                           :mouseLeaveDelay="0">
                                    <span>{{ value2['meta']['title'] }}</span>
                                </a-tooltip>
                            </a-menu-item>
                        </div>
                    </a-sub-menu>
                </template>
            </a-menu>
        </a-layout-sider>
        <!-- Navigation Done ... -->

        <!-- Main Container -->
        <a-layout style="margin-left: 250px;">

            <!-- Main Header -->
            <a-layout-header :class="[
                'global-header',
                {
                    'global-header-scrolled': is_scrolled,
                    'no-header-shadow': headerShadowState.suppressShadow
                }
            ]" >

                <a-breadcrumb class="breadcrumb-navigation">
                    <a-breadcrumb-item v-for="item in route.matched" :key="item.path">
                        <router-link :to="item.path"> {{ item.meta.title }} </router-link>
                    </a-breadcrumb-item>
                </a-breadcrumb>

                <div class="space-holder" />
                <div class="header-tool-bar">
                    <a-popover>
                        <template #content >
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <span :style="{fontSize: Number(5) + Number(global_fontsize) + 'px', }">{{ user_data.username }}</span>
                            </div>

                            <a-menu
                                style="width: 250px;font-size: 18px;display:flex;align-items: center;flex-direction: column;"
                                mode="vertical"
                                :dashed="true"
                                v-model:selectedKeys="user_operate_select_key"
                                @select="()=>{user_operate_select_key=[]}"
                            >

                                <a-upload v-if="Object.keys(user_data).length" :fileList="upload_profile_picture_file" @change="upload_change" :before-upload="()=>{return false}" :showUploadList="false" style="display: flex;flex-direction: column;width: 100%; height: 100%;">
                                    <a-menu-item :key="`user_operate_1`">
                                        <UploadOutlined /><span :style="{fontSize: global_fontsize + 'px', }">Upload profile picture</span>
                                    </a-menu-item>
                                </a-upload><hr style="width: 90%;margin: 0px;align-self: center;">

                                <a-menu-item @click="skip_url('/login')" :key="`user_operate_2`">
                                    <LogoutOutlined />
                                    <span v-if="Object.keys(user_data).length" :style="{fontSize: global_fontsize + 'px', }" >Sign out</span>
                                    <span v-if="!Object.keys(user_data).length" :style="{fontSize: global_fontsize + 'px', }" >Sign in</span>
                                </a-menu-item><hr style="width: 90%;margin: 0px;">

                            </a-menu>
                        </template>
                        <img v-if="user_pic" :src="`${AXIOS_API}/info_management/get_avatar?pic=${user_pic}`"
                             style="border-radius: 50%;height: 40px;width: 40px;cursor: pointer;" />
                        <UserOutlined v-else style="background-color: #87d068;font-size: 30px;border-radius: 50%;" />
                    </a-popover>
                    <div style="height: 100%;display: flex;align-items: center;margin-right: 50px;">
                        <a-popover trigger="click">
                            <template #title>
                                <span style="font-size: 20px;">Font Size</span>
                            </template>
                            <template #content >
                                <div style="display: flex;justify-content: space-between;align-items: center;">
                                    <div style="height: 25px;width: 25px;" :style="icon_reduce_style" @mouseenter="() => {icon_config['reduce'] = true}" @mouseleave="() => {icon_config['reduce'] = false}" @click="fontsize_add_reduce(-1)">
                                        <MinusOutlined style="cursor: pointer;font-size: 25px;" />
                                    </div>

                                    <span :style="{fontSize: 25+'px',}">{{ global_fontsize }}</span>

                                    <div style="height: 25px;width: 25px;" :style="icon_add_style" @mouseenter="() => {icon_config['add'] = true}" @mouseleave="() => {icon_config['add'] = false}" @click="fontsize_add_reduce(1)">
                                        <PlusOutlined style="cursor: pointer; font-size: 25px" />
                                    </div>

                                    <a-button type="primary" style="border-radius: 25px;height: 40px;width: 60px;padding: 0;font-size: 18px;" @click="reset_fontsizt">reset</a-button>
                                </div>
                            </template>
                            <ZoomInOutlined style="color: rgb(179, 174, 174);font-size: 30px;" />
                        </a-popover>
                    </div>
                </div>
            </a-layout-header>

            <a-layout-content :style="{margin: 0}">
                <div>
                    <div class="scroll-sentinel" id="scroll-sentinel"></div>
                    <router-view  class="main-content" :key="`${refreshkey}_${$route.fullPath}`" ></router-view>
                    <!-- 通过key和url来刷新组件 -->
                </div>
            </a-layout-content>

        </a-layout>
    </a-layout>
</template>


<script setup>
import { ref, computed, onBeforeUnmount, onMounted, onUnmounted, reactive, provide } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { routes } from '@/components/router/index.js'
import { toRaw } from '@vue/reactivity'
import { LogoutOutlined, UploadOutlined } from '@ant-design/icons-vue'
import { AXIOS_API } from '@/views/storege/index'
import { message } from 'ant-design-vue'
import axios from 'axios'

// ===== 原 data =====
const router_list = ref([])
const background_black_url = ['/demo-video', '/reels-video', '/bts-video']
const global_fontsize = ref(14)
const refreshkey = ref(0)
const icon_config = ref({
    add: false,
    reduce: false
})
const user_pic = ref(null)
const upload_profile_picture_file = ref([])
const user_operate_select_key = ref([])
const user_data = ref({})

// ===== 全局头阴影控制 =====
const headerShadowState = reactive({ suppressShadow: false })
provide('headerShadowState', headerShadowState)

// ===== router =====
const route = useRoute()
const router = useRouter()

// ===== created =====
sessionStorage.setItem("global_fontsize", global_fontsize.value)
init_layout()

let storage_user_data = JSON.parse(sessionStorage.getItem('user_data'))
if (storage_user_data){
    user_data.value = storage_user_data
}
if(user_data.value.pic_url){
    user_pic.value = user_data.value['pic_url']
}

// ===== computed =====
const icon_add_style = computed(() => {
    if (icon_config.value['add']){
        return {backgroundColor: 'rgb(185, 183, 183)', borderRadius: 50+'%'}
    }
    return {}
})

const icon_reduce_style = computed(() => {
    if (icon_config.value['reduce']){
        return {backgroundColor: 'rgb(185, 183, 183)', borderRadius: 50+'%'}
    }
    return {}
})

// 导航栏选项
const selectedKeys = computed(() => {
    return [route.path]
})

// 导航栏展开选项
const openkeys = computed(() => {
    let openKeys = sessionStorage.getItem('layouts_openKeys')
    if(openKeys){
        return openKeys.split(',')
    }else{
        return ['0_1']
    }
})



// ===== methods =====
function init_layout(){
    let routerData = JSON.parse(JSON.stringify(routes))
    for(let i=0; i<routerData.length;i++){
        if(!routerData[i]['hidemenu']){
            if('children' in routerData[i] && routerData[i]['children']){
                for(let i1=0; i1<routerData[i]['children'].length;i1++){
                    if(!routerData[i]['children'][i1]['hidemenu']){
                        router_list.value.push(routerData[i]['children'][i1])
                        router_list.value = JSON.parse(JSON.stringify(router_list.value))
                        router_list.value[router_list.value.length-1]['children'] = []

                        if('children' in routerData[i]['children'][i1] && routerData[i]['children'][i1]['children']){
                            for(let i2=0; i2<routerData[i]['children'][i1]['children'].length;i2++){
                                if(!routerData[i]['children'][i1]['children'][i2]['hidemenu']){
                                    router_list.value[router_list.value.length-1]['children'].push(
                                        routerData[i]['children'][i1]['children'][i2]
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


function skip_url(url){
    if(url == route.fullPath){
        refreshkey.value++
    }else{
        router.push(url)
    }
}


function fontsize_add_reduce(value){
    global_fontsize.value += value
    // 保留你原来的逻辑（虽然 default_font 没定义）
    this.default_font += value
    sessionStorage.setItem("global_fontsize", global_fontsize.value)
    refreshkey.value++
}


function reset_fontsizt(){
    global_fontsize.value = JSON.parse(JSON.stringify(14))
    sessionStorage.setItem("global_fontsize", global_fontsize.value)
    refreshkey.value++
}


function role_check(title_role){
    if(!title_role){
        return true
    }
    let title_role_data = toRaw(title_role)
    let user_data_storage = JSON.parse(sessionStorage.getItem('user_data'))
    if (!user_data_storage){
        return false
    }
    if (title_role_data.includes(user_data_storage.role_id)){
        return true
    }
}

function upload_upload_profile_picture(){
    let form_data = new FormData()
    form_data.append('pic', upload_profile_picture_file.value[0].originFileObj)

    axios.request({
        method: 'post',
        url: `${AXIOS_API}/info_management/upload_avatar`,
        data: form_data
    }).then((response)=> {
        if(response.data.code== 200){
            message.success(response.data.message)
            user_pic.value = `${response.data.data.new_user_pic}`
        }
    })
}


function upload_change(value){
    if(upload_profile_picture_file.value.length === 0){
        upload_profile_picture_file.value = value.fileList
        upload_upload_profile_picture()
        upload_profile_picture_file.value = []
    }
}


function openChange(openKeys){
    sessionStorage.setItem("layouts_openKeys", openKeys)
}


let observer = null
const is_scrolled = ref(false)

function handle_scroll_sentinel() {
    const sentinel = document.querySelector('#scroll-sentinel')
    observer = new IntersectionObserver(
        ([entry]) => { is_scrolled.value = !entry.isIntersecting },
        {root: null, threshold: 0, rootMargin: '5px 0px 0px 0px'} // 👈 控制触发距离（相当于 80px 阈值）
    )
    if (sentinel) { observer.observe(sentinel) }
}


// ===== beforeUnmount =====
onBeforeUnmount(()=>{
    sessionStorage.clear()
})


onMounted(() => {
    handle_scroll_sentinel()
})

onUnmounted(() => {
    if (observer) observer.disconnect()
})


</script>


<style scoped>


.main-title {
    font-size: 1.5em;
    font-family: 'GoogleSans', sans-serif;
    font-weight: 500;
    width: 100em;
    color: #3c3c3c;
    text-shadow: 2px 2px 2px rgba(163, 192, 207, 0.74);
}


.main-content {
    padding-top: 4.5em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    background:
        linear-gradient(
            to bottom,
            rgba(255,255,255,0.5) 0px,
            rgba(255,255,255,0.7) 50px,
            rgba(255,255,255,1) 140px,
            #ffffff 200px,
            #ffffff 100%
        ),
        url('~@/assets/images/bg.png') no-repeat top center;
    background-size: contain;
}


.breadcrumb-navigation {
    width: 100%;
    font-family: 'GoogleSans', sans-serif;
    font-size: 1.1em;
}


.header-holder {
    height: 3.5em;
}

.space-holder {
    width: 100%;
}

.header-tool-bar {
    gap: 1em;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.global-header {
    gap: 1em;
    position: fixed;
    background: rgba(255, 255, 255, 0.2);
    height: 3.5em;
    min-height: 3.5em;
    width: 100%;
    display: flex;
    padding-right: 250px;
    padding-left: 1.5em ;
    justify-content: flex-start;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(2px); /* 添加磨砂效果 */
    border-bottom: white;
    -webkit-backdrop-filter: blur(3px);
}

.global-header-scrolled {
    gap: 1em;
    position: fixed;
    background: rgba(255, 255, 255, 0.2);
    height: 3.5em;
    min-height: 3.5em;
    width: 100%;
    display: flex;
    padding-right: 250px;
    padding-left: 1.5em ;
    justify-content: flex-start;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(5px); /* 添加磨砂效果 */
    border-bottom: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    border-bottom: 1px rgba(184, 184, 184, 0.7) solid;
    -webkit-backdrop-filter: blur(10px);
    animation: linear 0.5s ease-out;
}

.global-header-scrolled.no-header-shadow {
    box-shadow: none;
}

.main-logo-container {
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.basic_layout-layout_sider {
    position: fixed;
    height: 100vh;
    overflow: auto
}

/* 针对该容器的滚动条 */
.basic_layout-layout_sider::-webkit-scrollbar {
    width: 6px;
}

.mini-split-line {
    background-color: black;
    border: none;
    height: 2px;
}


:deep(.ant-menu-dark .ant-menu-item) {
    border-radius: 0.3em !important;
}

:deep(.ant-menu-dark .ant-menu-item.ant-menu-item-selected) {
    border-radius: 0.3em !important;
    background-color: #3878cf !important; /* 选中时的背景色 */
    color: white !important; /* 选中时的文字颜色 */
}

.scroll-sentinel {
}

.logo {
    margin-top: 5px;
    height: 30px;
    cursor: pointer;
}

.basic_layout-layout_sider::-webkit-scrollbar-thumb {
    background: #1677ff;
    border-radius: 3px;
}

.basic_layout-layout_sider::-webkit-scrollbar-track {
    background: #f0f0f0;
}
</style>